export enum LayoutItemType {
  PRODUCT = "PRODUCT",
  PRODUCT_PAGE = "PRODUCT_PAGE",
  MENU_LINK = "MENU_LINK",
  WEBSITE = "WEBSITE",
  DISCOUNT = "DISCOUNT",
  GIFT_CARD = "GIFT_CARD",
  GIFT_CARD_LOOKUP = "GIFT_CARD_LOOKUP",
  PRODUCT_SEARCH = "PRODUCT_SEARCH",
  BARCODE_MODAL = "BARCODE_MODAL",
  SCALE_VALUE = "SCALE_VALUE",
  SHOW_CLOCK = "SHOW_CLOCK",
  SHOW_DATE = "SHOW_DATE",
  OPEN_CASHBOX = "OPEN_CASHBOX",
  ACTIVE_TAB = "ACTIVE_TAB",
  SPLIT_TAB = "SPLIT_TAB",
  PRINT_PROFORMA = "PRINT_PROFORMA",
  FORWARD_PREP_STATION = "FORWARD_PREP_STATION",
  WAIT_PREP_STATION = "WAIT_PREP_STATION",
  COMBINED_PREP_TICKET = "COMBINED_PREP_TICKET",
  TOGGLE_TAKEAWAY = "TOGGLE_TAKEAWAY",
  TEXT_ITEM = "TEXT_ITEM",
  SELECT_STORE = "SELECT_STORE",
  SET_REFERENCE = "SET_REFERENCE",
  ORDER_PAGE = "ORDER_PAGE",
  STAFF_SELECT = "STAFF_SELECT",
  SHOW_ALL = "SHOW_ALL",
  PAYMENT_METHOD = "PAYMENT_METHOD",
  SELECT_CUSTOMER = "SELECT_CUSTOMER",
  SERVICE_ORDER = "SERVICE_ORDER",
  SERVICE_ORDER_DEPOSIT = "SERVICE_ORDER_DEPOSIT",
  TEMPORARILY_OUT_OF_STOCK = "TEMPORARILY_OUT_OF_STOCK",
  PRODUCT_LOOKUP = "PRODUCT_LOOKUP",
}
